import React from 'react';
import './index.css'
import {
  FaFacebookSquare,
  FaGithubSquare,
  FaInstagram,
  FaTwitterSquare,
  FaYoutubeSquare,
} from 'react-icons/fa';
import Logo from '../../../assets/LogoBarra.png';

const Footer = () => {
  return (
    <div className='footer-container'>
      <div>
        <img src={Logo} className='footer-logoApp'/>
        <p className='footer-descripcion' style={{ color: 'white', fontWeight: '500'}}>Desarrollado con dedicación por 
          <strong style={{ color: '#f98806'}}> Brayan Calderón</strong> y <strong style={{ color: '#f98806'}}>Nestor Martínez</strong>, 
          estudiantes de Ingeniería en Sistemas, ofreciendo una solución integral para la gestión bibliotecaria.</p>
        <div className='footer-redesIcons'>
            <a href="https://www.facebook.com/UAMNicaragua" target="_blank" rel="noreferrer" className='footer-enlaces'><FaFacebookSquare size={30} /></a>
            <a href="https://www.instagram.com/uam.nicaragua/" target="_blank" rel="noreferrer" className='footer-enlaces'><FaInstagram size={30} /></a>
            <a href="https://x.com/UAMNica" target="_blank" rel="noreferrer" className='footer-enlaces'><FaTwitterSquare size={30} /></a>
            <a href="https://www.youtube.com/user/UAMNica" target="_blank" rel="noreferrer" className='footer-enlaces'><FaYoutubeSquare size={30} /></a>
            <a href="https://github.com/brayancode2004" target="_blank" rel="noreferrer" className='footer-enlaces'><FaGithubSquare size={30} /></a>
        </div>
      </div>
      <div className='footer-links-container'>
    <div className='footer-links-column'>
        <h6 className='footer-ColumnsTitle'>NOSOTROS</h6>
        <ul className="footer-list-links">
            <a href="https://uam.edu.ni/nosotros/#historia" target="_blank" rel="noreferrer" className='footer-enlaces'> <li className='footer-links'>Historia</li></a>
            <a href="https://uam.edu.ni/nosotros/#mision" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Misión, Visión y Valores</li></a>
            <a href="https://uam.edu.ni/nosotros/#proyecto" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Proyecto Educativo</li></a>
            <a href="https://uam.edu.ni/noticias-eventos/" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Noticias y Eventos</li></a>
            <a href="https://uam.edu.ni/directorio-uam/" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Directorio</li></a>
        </ul>
    </div>
    <div>
        <h6 className='footer-ColumnsTitle'>ADMISIÓN</h6>
        <ul className="footer-list-links">
        <a href="https://uam.edu.ni/admision/" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Proceso de Admisión</li></a>
        <a href="https://uam.edu.ni/admision/#aranceles" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Aranceles</li></a>
        <a href="https://uam.edu.ni/admision/#becas" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Becas y financiamiento</li></a>
        <a href="https://uam.edu.ni/carreras-de-grado/" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Carreras de Grados</li></a>
        <a href="https://posgrado.uam.edu.ni/" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Posgrado</li></a>
        </ul>
    </div>
    <div>
        <h6 className='footer-ColumnsTitle'>IDIOMAS E INSTITUTOS</h6>
        <ul className="footer-list-links">
        <a href="https://uam.edu.ni/language-center/" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Language Center</li></a>
        <a href="https://uam.edu.ni/etica-valores-desarrollo/" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Instituto de Ética, valores y desarrollo</li></a>
        <a href="https://www.facebook.com/UAMNicaragua" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Biblioteca Pablo Antonio Cuadra</li></a>
        <a href="https://uam.edu.ni/programa-emprendedores/" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Programa Emprendedores</li></a>
        <a href="http://ip.uam.edu.ni/" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>UAM Internacional</li></a>
        </ul>
    </div>
    <div>
        <h6 className='footer-ColumnsTitle'>VIDA ESTUDIANTIL</h6>
        <ul className="footer-list-links">
        <a href="https://uam.edu.ni/calendario-reglamentos/" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Calendario y reglamentos</li></a>
        <a href="https://uam.edu.ni/deporte/" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Deporte</li></a>
        <a href="https://uam.edu.ni/cultura/" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Cultura</li></a>
        <a href="https://uam.edu.ni/consejeria/" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Consejería</li></a>
        <a href="https://www.facebook.com/UAMNicaragua" target="_blank" rel="noreferrer" className='footer-enlaces'><li className='footer-links'>Servicio estudiantil</li></a>
        </ul>
    </div>
      </div>
    </div>
  );
};

export default Footer;